import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { euro } from "@/lib/api";
import { useRoutes } from "@/lib/useRoutes";

export const PriceTable = () => {
  const { data: routes = [], isLoading } = useRoutes();
  return (
    <div className="card-soft overflow-hidden border border-slate-200 bg-white" data-testid="price-table">
      <div className="hidden grid-cols-12 border-b border-slate-200 bg-silver/60 px-6 py-4 text-[11px] font-medium uppercase tracking-[0.2em] text-slate-500 md:grid">
        <span className="col-span-7">Route</span>
        <span className="col-span-2 text-right">Price</span>
        <span className="col-span-3" />
      </div>
      {isLoading && <p className="px-6 py-8 text-sm text-slate-500">Loading prices…</p>}
      {routes.map((r) => (
        <div
          key={r.id}
          className="grid grid-cols-12 items-center gap-y-3 border-b border-slate-100 px-5 py-5 transition-colors last:border-0 hover:bg-gold-light/50 md:px-6"
          data-testid={`price-row-${r.destination.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        >
          <div className="col-span-8 md:col-span-7">
            <p className="text-xs text-slate-500">{r.origin}</p>
            <p className="mt-1 font-serif text-xl text-ink md:text-2xl">→ {r.destination}</p>
          </div>
          <p className="col-span-4 text-right font-serif text-2xl text-ink md:col-span-2 md:text-3xl">{euro(r.price)}</p>
          <div className="col-span-12 md:col-span-3 md:text-right">
            <Link
              to={`/booking?pickup=${encodeURIComponent(r.origin)}&dropoff=${encodeURIComponent(r.destination)}`}
              className="inline-flex items-center gap-2 text-sm font-medium text-ink underline decoration-gold underline-offset-[6px] hover:text-gold-hover"
              data-testid={`price-book-${r.destination.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              Book this route <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};
